import React from 'react';
import ContextHelp from './ContextHelp';
import FinanzasSelloConfianza from './FinanzasSelloConfianza';
import { GANANCIAS_SUBTITULO, HELP_GANANCIAS_MES } from '../../../utils/finanzasUi';

/**
 * Tarjeta unificada de ganancias + sello de confianza (Dashboard y Centro).
 */
export default function GananciasFinancieraCard({
  titulo = 'Ganancias del mes',
  valor,
  cobertura,
  calidadFinanciera,
  actualizadoEn,
  compact = false,
  renderValor
}) {
  const titleClass = compact ? 'text-xs font-medium text-e0e3-muted' : 'text-sm font-medium text-e0e3-muted';
  const padClass = compact ? 'p-5' : 'p-5 lg:p-6';
  const valueClass = compact ? 'text-2xl' : 'text-2xl lg:text-3xl';

  return (
    <div className={`rounded-xl border border-e0e3-border/40 bg-e0e3-surface/40 ${padClass} min-h-[7rem] flex flex-col justify-center`}>
      <p className={`${titleClass} flex items-center gap-1.5`}>
        {titulo}
        <ContextHelp text={HELP_GANANCIAS_MES} label={`Ayuda sobre ${titulo.toLowerCase()}`} />
      </p>
      <p className={`${valueClass} font-bold text-emerald-300 mt-2`}>
        {renderValor ? renderValor(valor) : valor}
      </p>
      <p className={`${compact ? 'text-[11px]' : 'text-xs'} text-e0e3-muted mt-2`}>{GANANCIAS_SUBTITULO}</p>
      <FinanzasSelloConfianza
        cobertura={cobertura}
        calidadFinanciera={calidadFinanciera}
        actualizadoEn={actualizadoEn}
        compact={compact}
      />
    </div>
  );
}
